import React, { useEffect, useRef, useState } from 'react'
import Svg from '../../../common/Svg'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getSurveyFormData, getSurveySectionData, submitResponseData, submitSurveyData, getSurveyDetail } from '../../../store/actions/surveyFormAction'
import Section from './Section'
import { clearAllFields } from '../../../store/actions/surveyFieldDataAction'
import { triggerWebhookBackend } from "../../../store/actions/surveyFormAction";


const SectionWiseSurvey = () => {

    //==> States <==
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { survey_id, ss_id } = useParams();
    const { surveyFormQuestions, surveySections } = useSelector((state) => state.surveyData)
    const { surveyFieldsData } = useSelector((state) => state.surveyFieldData)

    const [sectionWiseQuestion, setSectionWiseQuestion] = useState([])
    const [currentSection, setCurrentSection] = useState(null)
    const [lastRespondedQuestion, setLastRespondedQuestion] = useState('')
    const [currentSectionWidth, setCurrentSectionWidth] = useState(0)
    const surveyDetail = useSelector((state) => state.surveyData?.surveyDetail)
    const [pageHeading, setPageHeading] = useState("");
    const [buttonHeading, setButtonHeading] = useState("");
    const [buttonHeadingNext, setButtonHeadingNext] = useState("");
    const [buttonBack, setButtonBack] = useState("");
    const surveyLangName = surveyDetail?.length > 0 ? surveyDetail[0]?.language_name?.toLowerCase() : "english";




    const progressBar = useRef(null)


    //==> Functionalities <==

    //Data handling
    const getSectionClass = (target, sections, current) => {
        const progressClass = 'in-progress'
        if (!current || !target || sections.length === 0) {
            return ''
        }

        if (target === current) {
            return progressClass
        }

        let isComplete = true
        sections.some((section) => {
            if (section.id === target) {
                return true
            }
            if (section.id === current) {
                isComplete = false
            }
            return false
        })

        if (isComplete) {
            return progressClass
        }

        return ''
    }

    const calculateWidth = (target, sections, current) => {
        if (!current || !target || sections.length === 0) {
            return 0
        }

        if (target === current) {
            return ((100 / (sections.length - 1)) * currentSectionWidth)
        }

        let isComplete = true
        sections.some((section) => {
            if (section.id === target) {
                return true
            }
            if (section.id === current) {
                isComplete = false
            }
            return false
        })

        if (isComplete) {
            return (100 / (sections.length - 1))
        }

        return 0
    }

    const scrollToNextQue = (currentQue) => {
        const scrollByHeight = document.getElementById(`qusDiv_${currentQue}`).offsetHeight

        const currentScroll = window.scrollY
        window.scrollTo({
            top: currentScroll + scrollByHeight,
            behavior: 'smooth',
        })

        // let currentScroll = 0
        // const scrolling = setInterval(() => {
        //     window.scrollBy(0, 10)
        //     currentScroll += 10
        //     console.log('scrollByHeight', scrollByHeight, currentScroll)
        //     if (currentScroll >= scrollByHeight) {
        //         console.log('Clrear interval fire')
        //         clearInterval(scrolling)
        //     }
        // }, 5)

    }

    const genSerialAndResponse = (values, questionId, questionValue) => {
        let serialNo = ''
        let responseNo = ''
        sectionWiseQuestion?.forEach((section) => {
            section.questions?.forEach((question) => {
                if (values && values[section.id]) {
                    serialNo += `${question.su_question_id}#`
                    if (question.su_question_id === questionId) {
                        responseNo += `${questionValue ?? ''}#`
                    } else {
                        responseNo += `${values[section.id][question.su_question_id] ?? ''}#`
                    }
                }
            })
        })

        return { responseNo, serialNo }
    }

    const getStartCount = (sections, index) => {
        let count = 1

        sections?.some((section, i) => {
            if (i < index) {
                const questions = section.questions
                count += questions?.length
            }
            return i === index
        })

        return count
    }

    //Submit responses
    const submitResponse = (questionId, questionValue) => {
        scrollToNextQue(questionId)
        const { responseNo, serialNo } = genSerialAndResponse(surveyFieldsData, questionId, questionValue)
        const payload = {
            response: responseNo,
            serial_no: serialNo,
            current_question: questionId,
            ss_id: ss_id
        }
        setLastRespondedQuestion(questionId)
        dispatch(submitResponseData(payload)).then(() => {
            // Custom webhook trigger logic (same as LandingPage.js)
            dispatch(triggerWebhookBackend(survey_id, "RESPONSE_SUBMIT", ss_id));
        });
    }

    const handleSubmitSurvey = () => {
        const { responseNo, serialNo } = genSerialAndResponse(surveyFieldsData, -1, -1)
        const payload = {
            response: responseNo,
            serial_no: serialNo,
            current_question: lastRespondedQuestion,
            survey_id: survey_id,
            ss_id: ss_id
        }
         dispatch(submitSurveyData(payload, navigate)).then(() => {
            // Custom webhook trigger logic (same as LandingPage.js)
            dispatch(triggerWebhookBackend(survey_id, "SURVEY_SUBMIT", ss_id));
        });
        dispatch(clearAllFields())
    }


    //==> Effects <==
    useEffect(() => {
        let token = localStorage.getItem("customer_token")
        if (!token || !ss_id || ss_id === 'undefined' || !survey_id) {
            navigate('/')
        }
        dispatch(getSurveySectionData({
            "survey_id": survey_id
        }))
        dispatch(getSurveyFormData({
            "survey_id": survey_id
        }))
        dispatch(getSurveyDetail({ "survey_id": survey_id }))
    }, [ss_id, survey_id])

    useEffect(() => {
        if (surveyDetail?.length > 0) {
            console.log("survey detail-------", surveyDetail)
            // setTheme([surveyDetail[0].theme_selected]);
            setPageHeading(surveyDetail[0].questionaire_heading)
            setButtonHeading(surveyDetail[0].questionaire_button_heading);
            setButtonHeadingNext(surveyDetail[0].questionaire_button_next);  
            setButtonBack(surveyDetail[0].questionaire_button_back);    
        }

    }, [surveyDetail])



    useEffect(() => {
        if (surveySections && surveyFormQuestions?.length > 0) {
            let data = {}
            surveyFormQuestions?.forEach((question) => {
                const sectionId = question.su_section_id
                if (!data[sectionId]) {
                    data[sectionId] = {
                        id: sectionId,
                        name: surveySections[sectionId]?.name,
                        order: Number(surveySections[sectionId]?.order),
                        questions: [],
                        desc: surveySections[sectionId]?.desc
                    }
                }
                data[sectionId].questions.push(question)
            })

            Object.keys(data ?? {})?.forEach((section) => {
                const questions = data[section].questions
                const sortedQuestions = questions.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
                data[section].questions = sortedQuestions
            })

            let tmpData = Object.keys(data ?? {})?.map((section) => (data[section]))
            tmpData = tmpData?.sort((a, b) => a.order - b.order)

            setCurrentSection(tmpData.length > 0 && tmpData[0].id)
            setSectionWiseQuestion(tmpData);
        }
    }, [surveyFormQuestions, surveySections])


    return (
        <>
            <div className='banner-section-qna bg-img new-banner'>
                <div className="container">
                    <div className="row">
                        <div className='col-lg-8 d-flex align-items-center'>
                            <div className="left-logo">
                                <Svg name="vodafone-logo-small" />
                            </div>
                            <div className="text-wrap flex-grow-1">
                                {/* <div className="logo-wrap">
                                    <Svg name="vodafone-logo" />
                                </div> */}
                                {/* <p><strong>Vodafone</strong> Business</p> */}
                                <h1>{pageHeading}</h1>
                            </div>
                        </div>
                        {/* <div className='col-md-4 col-lg-5 image-cen'>
                            <div className="img-wrap">
                                <img src={bannerImg} alt='bannerImg' className='img-fluid' />
                            </div>
                        </div> */}
                    </div>

                </div>
            </div>
            <div className="qna-section-wrap">
                <div className="qna-progress" ref={progressBar}>
                    <div className="container">
                        <div className="prograss-wrap ">
                            <div className="prograss-bg">
                                {
                                    sectionWiseQuestion?.map((section, index, arr) => {
                                        if (index + 1 === arr.length)
                                            return ''
                                        return (
                                            <div
                                                className="prograss-active group-1"
                                                style={{ width: `${calculateWidth(section.id, arr, currentSection)}%` }}
                                                key={index}
                                            />
                                        )
                                    })
                                }
                            </div>
                            <div className="prograss-listing">
                                <ul>
                                    {
                                        sectionWiseQuestion?.map((section, index, arr) => {
                                            return (
                                                <li className={`${getSectionClass(section.id, arr, currentSection)} group-${index}`} key={index}>
                                                    <div className="text-wrap">{section.name}</div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="questions-wrapper">
                    {
                        sectionWiseQuestion?.map((section, index, arr) => {
                            const questions = section.questions
                            const startCount = getStartCount(arr, index)

                            if (currentSection === section.id) {
                                return (
                                    <Section
                                        key={section.id}
                                        survey_id={survey_id}
                                        ss_id={ss_id}
                                        sectionId={section.id}
                                        previousSection={index === 0 ? null : arr[index - 1].id}
                                        nextSection={index + 1 === arr.length ? null : arr[index + 1].id}
                                        questions={questions}
                                        setCurrentSection={setCurrentSection}
                                        name={section.name}
                                        desc={section.desc}
                                        submitResponse={submitResponse}
                                        handleSubmitSurvey={handleSubmitSurvey}
                                        setCurrentSectionWidth={setCurrentSectionWidth}
                                        startCount={startCount}
                                        progressBar={progressBar}
                                        buttonNext={buttonHeadingNext}
                                        buttonHeading={buttonHeading}
                                        buttonBack={buttonBack}
                                        surveyLangName={surveyLangName}
                                    />
                                )
                            } else {
                                return ''
                            }
                        })
                    }
                </div>
            </div >
        </>
    )
}

export default SectionWiseSurvey